import SOFAScore from "../../components/SOFAScore/SOFAScore";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { updateClinicalScore } from "../../helper/clinical-checks";
import { getCookieCustom } from "../../common/utils/StorageUItils";
import { CLINICAL_SCORE_ACTIVE_DATE } from "../../common/constant/common-constants";
import { redirect } from "../../common/utils/RedirectionUtils";
import { PAGE_CONST } from "../../common/constant/page-constants";
import moment from "moment";
import "./SOFAScorePage.scss";

function SOFAScorePage(props) {
    const params = useParams();
    const navigate = useNavigate();
    const [bedId, setBedId] = useState(null);
    const [sessionId, setSessionId] = useState(null);
    const [confirmScreen, setConfirmScreen] = useState(false);
    const [score, setScore] = useState(null);
    const [scoreDate, setScoreDate] = useState(null);

    useEffect(() => {
        if (params.id) {

            setBedId(params.id);
            if (props.patientData[params.id]) setSessionId(props.patientData[params.id].sessionId);
        }
        let date = getCookieCustom(CLINICAL_SCORE_ACTIVE_DATE);
        setScoreDate(date);
    }, [])

    const handleSubmitClick = (score) => {
        setConfirmScreen(true);
        setScore(score);
    }
    const handleCancelClick = () => {
        setConfirmScreen(false)
    }
    const handleConfirmClick = () => {
        let dataObj = {
            bedId: bedId,
            patientSessionId: sessionId,
            date: scoreDate,
            gcs: null,
            sofa: score,
            time: moment(new Date()).format("HH:00")
        }
        updateClinicalScore(dataObj).then((res) => {
            redirect(navigate, PAGE_CONST.BED_DETAILS, dataObj);

        }).catch((err) => {
            console.log("some error occured", err)
        })
        setConfirmScreen(false)
    }
    return (
        <>
            <SOFAScore handleSubmitClick={(score) => handleSubmitClick(score)} />
            {confirmScreen &&
                <div className="confirm-modal-container">
                    <div className="confirm-message">Are you sure you want to submit the scores?</div>
                    <div className="confirm-btn-container">
                        <div className="common-btn" onClick={handleCancelClick}>Cancel</div>
                        <div className="common-btn default-btn" onClick={handleConfirmClick}>Confirm</div>
                    </div>

                </div>}
        </>
    )
}

const mapStateToProps = (state, ownProps) => {

    let patientData = state.patientDataReducer.patientData;
    return {
        patientData: patientData,
        config: state.configReducer.config
    };
};
export default connect(mapStateToProps)(SOFAScorePage);
